import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const NotificationBox = styled.div`
  max-width: 450px;
  min-height: 360px;
  width: 100%;
  border-radius: ${({ theme }) => theme.misc.tileBRadius};
  background-color: ${({ theme }) => theme.white.a10};
  padding: 30px;
  font-size: 1.6em;
  color: ${({ theme }) => theme.brandBlue.light};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${media.phone`
    padding-right: 15px;
    padding-left: 15px;
  `}
`;

export const SuccessContainer = styled(NotificationBox)`
  &.in_progress {
    > div {
      margin-top: 25px;

      &.new_style {
        > div {
          background-color: ${({ theme }) => theme.brandBlue.light};
        }
      }
    }
  }
`;

export const UnauthorizedPagesContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    height: 100%;
    padding: 15px;
    background: linear-gradient(to right, ${theme.brandBlue.medium}, ${theme.brandBlue.dark});
    color: ${theme.white.a10};
    /* stylelint-disable no-descending-specificity  */
    > div.new_style {
      background-color: ${theme.white.a10};
      > div {
        background-color: ${theme.brandBlue.medium};
      }
    }
    /* stylelint-enable */

    ${media.phone`
      padding: 80px 15px 50px;
    `}
  `,
);

export const PasswordBoxContainer = styled.div`
  max-width: 359px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.phone`
    min-width: 100%;
  `}
`;

export const PasswordForm = styled.form`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const PasswordHeader = styled.header`
  margin-bottom: 25px;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
`;

export const PasswordSubline = styled.div`
  font-size: 1rem;
  font-weight: normal;
  line-height: 26px;
  color: ${({ theme }) => theme.white.a10};
`;

export const PasswordTitleHeader = styled.h1`
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 45px;
  color: ${({ theme }) => theme.white.a10};
`;
